<main class="" id="content-page">
  <div class="container main-panel">
    <app-header-ad [position]="'top'"></app-header-ad>
    <app-breadcrumbs *ngIf="breadcrumbs.length > 1" [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div *ngIf="showTopics" class="article-inner-container" style="margin-right: 10px; margin-left: 10px">
          <h1>Video-Courses <i [ngStyle]="{display: isLoading()}"
              style="color: #337ab7; font-weight: 800; font-size: 22px; margin-left: 20px"
              class="fa fa-spinner fa-spin"></i></h1>
          <hr />

          <div *ngIf="showVideo && !playingVideo">
            <img loading="lazy" id="showVideoImage" (click)="playTheVideo()" src="/assets/img/LearnMore.png"
              alt="Learn More about Digital Badges" />
            <hr />
          </div>
          <div *ngIf="showVideo && playingVideo">
            <div class="embedded-video">
              <iframe id="PLAYER1" webkitallowfullscreen="" mozallowfullscreen="" loading="lazy"
                allow="autoplay; fullscreen" allowfullscreen frameborder="0"
                src="//player.vimeo.com/video/370068625?api=1&player_id=PLAYER1" width="640" height="360"
                class="note-video-clip">
              </iframe>
            </div>

            <button (click)="hideVideo()" class="btn digital-badge-help-buttons margin-top-10"><i
                class="fa fa-window-close" aria-hidden="true"></i> Close</button>
            <hr />
          </div>

          <ul class="nav nav-tabs ">
            <li [ngClass]="topicTabClass()">
              <a aria-expanded="true" (click)="showTheTopicTab()" [routerLink]="" data-toggle="tab">By Topic</a>
            </li>
            <li [ngClass]="latestClass()">
              <a aria-expanded="false" (click)="showTheLatestTab()" [routerLink]="" data-toggle="tab">Latest
                Video-Courses</a>
            </li>
            <li *ngIf="hasBadges()" [ngClass]="badgesClass()">
              <a aria-expanded="false" (click)="showTheBadgesTab()" [routerLink]="" data-toggle="tab">Earned Digital
                Badges</a>
            </li>
          </ul>

          <div *ngIf="displayTopicTab()" class="row">
            <div class="col-xl-3 col-lg-4 col-sm-6 col-xs-12 nav-panel-wrap"
              *ngFor="let video of ((videoCourses && videoCourses.indexModel) ? videoCourses.indexModel.TopicLeaves : [])">
              <app-display-topic [area]="topicArea" [topic]="video"></app-display-topic>
            </div>
          </div>
          <div *ngIf="displayLatestTab()" class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nav-panel-wrap"
              *ngFor="let aEntry of ((videoCourses && videoCourses.indexModel && videoCourses.indexModel.AllDigitalBadges) ? videoCourses.indexModel.AllDigitalBadges : []); let i=index">
              <a *ngIf="i < currentLatestCount" href=""
                [routerLink]="['/videocoursescontentview', aEntry.Information.Alias]"
                class="panel nav-panel courseware-panel mylazy" [style.background-image]="getImageUrl(aEntry)">
                <div class="panel-text-wrap">
                  <h2>{{aEntry.Information.Title}}</h2>
                </div>
                <div class="nav-panel-bkgd"></div>
              </a>
              <div *ngIf="i == (currentLatestCount + 3) && hasMoreLatest()" style="float: left">
                <button class="btn digital-badge-test-buttons btn-load-more" (click)="showMoreLatest()"
                  style="border-radius: 5px; font-size: 16px; font-weight: bold; width: 200px">Load More</button>
              </div>
            </div>
          </div>
          <div *ngIf="displayEarnedTab()" class="row">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nav-panel-wrap"
              *ngFor="let aEntry of ((videoCourses && videoCourses.indexModel && videoCourses.indexModel.EarnedBadgess) ? videoCourses.indexModel.EarnedBadgess : [])">
              <a *ngIf="displayEarnedTab()" href=""
                [routerLink]="['/videocoursescontentview', aEntry.Information.Alias]"
                class="panel nav-panel courseware-panel mylazy" [style.background-image]="getImageUrl(aEntry)">
                <div class="panel-text-wrap">
                  <h2>{{aEntry.Information.Title}}</h2>
                </div>
                <div class="nav-panel-bkgd"></div>
              </a>
            </div>
          </div>
        </div>
        <span *ngIf="currentTopic && showContentEntries">
          <div class="row" style="margin-right: 10px; margin-left: 10px">
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 nav-panel-wrap"
              *ngFor="let contentEntry of currentTopic.contentEntries">
              <app-display-content-entry [area]="contentArea" [selectedTopic]="currentTopic"
                [contentEntry]="contentEntry"></app-display-content-entry>
            </div>
          </div>
        </span>
      </div>
    </div>
    <app-header-ad [position]="'bottom'"></app-header-ad>
  </div>
</main>